export default {
    methods: {
        formattedDate(datetime, format = 'DD/MM/YYYY hh:mm A') {
            return moment(datetime).format(format);
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/formatted-date.js